package com.wharpe.finsimweb

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.ButtonStyle
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import com.varabyte.kobweb.silk.components.layout.HorizontalDividerStyle
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.addVariantBase
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.modifyStyleBase
import org.jetbrains.compose.web.css.*

const val FontSans = "Inter"
const val FontMono = "Roboto Mono"

@InitSilk
fun initSiteStyles(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyle("html") {
        cssRule(CSSMediaQuery.MediaFeature("prefers-reduced-motion", StylePropertyValue("no-preference"))) {
            Modifier.scrollBehavior(ScrollBehavior.Smooth)
        }
    }

    ctx.stylesheet.registerStyleBase("body") {
        Modifier
            .fontFamily(
                FontSans, "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto",
                "Helvetica Neue", "sans-serif"
            )
            .fontSize(16.px)
            .lineHeight(1.5)
    }

    ctx.theme.modifyStyleBase(HorizontalDividerStyle) {
        Modifier.fillMaxWidth()
    }
}

val HeadlineTextStyle = CssStyle {
    base {
        Modifier
            .fontSize(2.125.cssRem)
            .lineHeight(1.24)
            .fontWeight(FontWeight.ExtraBold)
            .letterSpacing((-0.5).px)
            .textAlign(TextAlign.Start)
    }
    Breakpoint.MD {
        Modifier.fontSize(2.75.cssRem).lineHeight(1.18).letterSpacing((-1).px)
    }
}

val SubheadlineTextStyle = CssStyle.base {
    Modifier
        .fontSize(1.cssRem)
        .lineHeight(1.5)
        .textAlign(TextAlign.Start)
        .color(colorMode.toSitePalette().muted)
}

val MoneyStyle = CssStyle.base {
    Modifier
        .fontFamily(FontMono, "ui-monospace", "SFMono-Regular", "Menlo", "monospace")
        .fontWeight(FontWeight.SemiBold)
        .letterSpacing((-0.3).px)
}

val CircleButtonVariant = ButtonStyle.addVariantBase {
    Modifier.padding(0.px).borderRadius(50.percent)
}

val UncoloredButtonVariant = ButtonStyle.addVariantBase {
    Modifier.setVariable(ButtonVars.BackgroundDefaultColor, Colors.Transparent)
}
